// src/constants/auth.js
// 상수 간 관계를 이용한 개선된 버전
export const AUTH_CONSTANTS = {
    AUTO_LOGOUT_TIME_MINUTES: 30,
    get AUTO_LOGOUT_TIME_SECONDS() {
        return this.AUTO_LOGOUT_TIME_MINUTES * 60;
    },
    TOKEN_REFRESH_INTERVAL_MINUTES: 5,
    get TOKEN_REFRESH_INTERVAL_SECONDS() {
        return this.TOKEN_REFRESH_INTERVAL_MINUTES * 60;
    },
};
export const TIME_CONST = {
    MILLISECONDS_IN_SEC1: 1000,
    MILLISECONDS_IN_SEC5: 5 * 1000,
    MILLISECONDS_IN_MIN1: 1000 * 60,
    MILLISECONDS_IN_MIN2: 2 * 1000 * 60,
    MILLISECONDS_IN_MIN3: 3 * 1000 * 60,
    MILLISECONDS_IN_MIN4: 4 * 1000 * 60,
    MILLISECONDS_IN_MIN5: 5 * 1000 * 60,   
    MILLISECONDS_IN_MIN10: 10 * 1000 * 60,    
    MILLISECONDS_IN_MIN15: 15 * 1000 * 60,    
    MILLISECONDS_IN_MIN20: 20 * 1000 * 60,    
    MILLISECONDS_IN_MIN25: 25 * 1000 * 60,    
    MILLISECONDS_IN_MIN30: 30 * 1000 * 60,    
    SECONDS_IN_MIN1: 60,
    SECONDS_IN_MIN2: 2 * 60,
    SECONDS_IN_MIN3: 3 * 60,
    SECONDS_IN_MIN4: 4 * 60,
    SECONDS_IN_MIN5: 5 * 60,   
    SECONDS_IN_MIN10: 10 * 60,    
    SECONDS_IN_MIN15: 15 * 60,    
    SECONDS_IN_MIN20: 20 * 60,    
    SECONDS_IN_MIN25: 25 * 60,    
    SECONDS_IN_MIN30: 30 * 60,      
};
export const API_ENDPOINTS = {
    LOGIN: '/api/login',
    LOGOUT: '/api/logout',
    REFRESH_TOKEN: '/api/refresh-token',
};
export const LOCAL_STORAGE_KEYS = {
    TOKEN: 'auth_token',
    USER: 'auth_user',
    LAST_ACTIVITY: 'last_activity_time',
};